import { safeParseFloat } from "components/Payment/lib/numberUtils";

const CURRENCY_FORMATTER = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const formatCurrency = (amount: unknown) => {
  if (amount == null) {
    return "—";
  }

  const parsedAmount =
    typeof amount === "number" ? amount : safeParseFloat(String(amount));

  if (parsedAmount == null) {
    return "—";
  }

  return CURRENCY_FORMATTER.format(parsedAmount);
};
